<div class="tile">
  <div class="row">
    <div class="col-12">
      <h5 class="pb-3">{{ 'savings-plan.recommendations.SUGGESTIONS_HEADER' | transloco }}</h5>
      <p class="mt-2">
        {{ 'savings-plan.recommendations.SUGGESTIONS_DESCRIPTION' | transloco }}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      @if (activeSegment$ | async; as activeSegment) {
        <div class="nav nav-tabs">
          <div class="nav-item">
            <a
              class="nav-link cursor-pointer font-medium text-no-wrap"
              [class.active]="activeSegment === '300'"
              (click)="changeSelection('300')"
            >
              {{ 'savings-plan.recommendations.SUGGESTION_OPTION_300' | transloco }}
            </a>
          </div>
          <div class="nav-item">
            <a
              class="nav-link cursor-pointer font-medium text-no-wrap"
              [class.active]="activeSegment === '150'"
              (click)="changeSelection('150')"
            >
              {{ 'savings-plan.recommendations.SUGGESTION_OPTION_150' | transloco }}
            </a>
          </div>
          <div class="nav-item">
            <a
              class="nav-link cursor-pointer font-medium text-no-wrap"
              [class.active]="activeSegment === '100'"
              (click)="changeSelection('100')"
            >
              {{ 'savings-plan.recommendations.SUGGESTION_OPTION_100' | transloco }}
            </a>
          </div>
          <div class="nav-item">
            <a
              class="nav-link cursor-pointer font-medium text-no-wrap"
              [class.active]="activeSegment === '1'"
              (click)="changeSelection('1')"
            >
              {{ 'savings-plan.recommendations.SUGGESTION_OPTION_1' | transloco }}
            </a>
          </div>
          <div class="nav-item hidden-sm hidden-xs hidden-md placeholder"></div>
        </div>
      }
    </div>
  </div>
  <div class="row pt-3">
    <div class="col-md-12 col-xl-5 mb-4 mb-xl-0">
      <div class="d-flex justify-content-center align-items-center">
        <div class="chart-container">
          <canvas
            baseChart
            [datasets]="doughnutChartDatasets$ | async"
            [options]="doughnutChartOptions"
            [legend]="false"
            [type]="'doughnut'"
          ></canvas>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-7">
      @if (activeSuggestions$ | async; as activeSuggestions) {
        @for (suggestion of activeSuggestions; track $index) {
          <saving-plans-saving-plan-suggestion-item
            [suggestion]="suggestion"
            [suggestionPercentage]="suggestion.amount === 100 ? '100' : (suggestion | suggestionPercentage: activeSuggestions)"
            [color]="suggestion.amount === 100 ? suggestionColors[0] : suggestionColors[$index]"
          />
        }
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-right mb-3">
        <span class="zero-text p-xsmall-med">{{ 'savings-plan.recommendations.RECOMMENDED_BY' | transloco }}&nbsp;</span>
        <img class="logo" src="assets/svg/extraetf-logo.svg" alt="extra-etf-logo" />
      </div>
      <div class="d-flex justify-content-end">
        <web-design-system-button
          data-zid="adopt-recommendation"
          size="small"
          [routerLink]="savingsPlanForm"
          [queryParams]="multiSavingsPlanQueryParams$ | async"
        >
          {{ 'savings-plan.recommendations.btn' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  </div>
</div>
